import { render, staticRenderFns } from "./LayoutPublicHeader.vue?vue&type=template&id=3308a49f&scoped=true&functional=true"
import script from "./LayoutPublicHeader.vue?vue&type=script&lang=js"
export * from "./LayoutPublicHeader.vue?vue&type=script&lang=js"
import style0 from "./LayoutPublicHeader.vue?vue&type=style&index=0&id=3308a49f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "3308a49f",
  null
  
)

export default component.exports